import { CONTACT, NAV_LINKS } from '../content';
import Logo from './Logo';
import './Footer.css';

const SKY = { day: 'daytime', dawn: 'twilight', night: 'night' };

// `sky` is set when the page picked its look from the visitor's local time.
export default function Footer({ sky }) {
  return (
    <footer className="footer tone-dark" data-nav="dark">
      <div className="container footer__top">
        <div className="footer__brand">
          <Logo />
          <p>Software Engineering for Aviation</p>
        </div>
        <nav className="footer__cols" aria-label="Footer">
          <div>
            <h3>Explore</h3>
            {NAV_LINKS.map((link) => (
              <a key={link.href} href={link.href}>
                {link.label}
              </a>
            ))}
          </div>
          <div>
            <h3>Contact</h3>
            <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
            <a href={CONTACT.phone.href}>{CONTACT.phone.display}</a>
            <span>{CONTACT.location}</span>
          </div>
          <div>
            <h3>Legal</h3>
            <a href={`${process.env.PUBLIC_URL}/privacy-policy.html`}>Privacy policy</a>
          </div>
        </nav>
      </div>
      <div className="container footer__bottom">
        <span>© {new Date().getFullYear()} Average Quality</span>
        {sky && <span>This page follows your sky — it’s {SKY[sky]} where you are.</span>}
        <span className="mono">RMK THANKS FOR FLYING WITH US=</span>
      </div>
    </footer>
  );
}
